import { render, staticRenderFns } from "./dragged.vue?vue&type=template&id=70c3eacc&scoped=true&"
import script from "./dragged.vue?vue&type=script&lang=js&"
export * from "./dragged.vue?vue&type=script&lang=js&"
import style0 from "./dragged.vue?vue&type=style&index=0&id=70c3eacc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c3eacc",
  null
  
)

export default component.exports